import { ErrorMessage, Field, FieldProps } from 'formik';
import React, { Fragment } from 'react';

type FormikSelectProps = {
  name: string;
  label: string;
  children?: React.ReactNode | ((props: FieldProps) => React.ReactNode);
  as?: any;
};

export function FormikSelect({ name, label, ...rest }: FormikSelectProps) {
  return (
    <Fragment>
      <div className='flex items-center mb-2 text-sm font-bold text-dark-gray'>
        <label htmlFor={name}>{label}</label>
      </div>
      <Field id={name} name={name} {...rest} />
      <ErrorMessage name={name} />
    </Fragment>
  );
}
